var map = {
	"./EYFS.jpg": 7216,
	"./Image_fx.jpg": 1171,
	"./Kid15.jpg": 2481,
	"./apply.jpg": 6319,
	"./art1.jpg": 9343,
	"./art2.jpg": 5728,
	"./art3.jpg": 6861,
	"./art4.jpg": 2102,
	"./broad.jpg": 6423,
	"./bubbles.jpg": 1170,
	"./casual.jpg": 1676,
	"./challenge.jpg": 92,
	"./contact.jpg": 1103,
	"./core-values.jpg": 4519,
	"./create.jpg": 5447,
	"./cul3.jpg": 1820,
	"./drama1.jpg": 2941,
	"./drama2.jpg": 5138,
	"./drama3.jpg": 1519,
	"./drama4.jpg": 8788,
	"./eyfs.jpg": 3379,
	"./eyfs1.jpg": 263,
	"./future.jpg": 6546,
	"./honour.jpg": 2304,
	"./img1.jpg": 8365,
	"./img2.jpg": 9138,
	"./img3.jpg": 847,
	"./img4.jpg": 2564,
	"./inquire.jpg": 496,
	"./isa-44.jpg": 7213,
	"./isa-55.jpg": 4523,
	"./isa-fish1.jpg": 4818,
	"./isa-fish2.jpg": 4717,
	"./isa-fish3.jpg": 5488,
	"./isa-fish4.jpg": 6419,
	"./justice.jpg": 8928,
	"./kid4.jpg": 3299,
	"./kid5.jpg": 4774,
	"./new-eyfs-girl.jpg": 8264,
	"./new-primary-boy.jpg": 3793,
	"./new-primary.jpg": 4128,
	"./planet1.jpg": 7804,
	"./planet2.jpg": 9323,
	"./planet3.jpg": 3486,
	"./planet4.jpg": 549,
	"./planet5.jpg": 5720,
	"./playground.jpg": 6976,
	"./res.jpg": 5769,
	"./secondary.jpg": 3581,
	"./service.jpg": 854,
	"./sport1.jpg": 3100,
	"./sport2.jpg": 5899,
	"./sport3.jpg": 8062,
	"./sport4.jpg": 3061,
	"./sport6.jpg": 4295,
	"./staff/staff1.jpg": 4229,
	"./staff/staff10.jpg": 457,
	"./staff/staff11.jpg": 6108,
	"./staff/staff12.jpg": 7627,
	"./staff/staff13.jpg": 1790,
	"./staff/staff14.jpg": 1234,
	"./staff/staff15.jpg": 4024,
	"./staff/staff16.jpg": 519,
	"./staff/staff17.jpg": 4714,
	"./staff/staff18.jpg": 6769,
	"./staff/staff2.jpg": 90,
	"./staff/staff3.jpg": 5895,
	"./staff/staff4.jpg": 1484,
	"./staff/staff5.jpg": 5833,
	"./staff/staff6.jpg": 7166,
	"./staff/staff7.jpg": 3003,
	"./staff/staff8.jpg": 1248,
	"./staff/staff9.jpg": 5821,
	"./storyHero.jpg": 3756,
	"./summit1.jpg": 8485,
	"./summit2.jpg": 5882,
	"./summit3.jpg": 9719,
	"./teaching1.jpg": 8473,
	"./teaching10.jpg": 7317,
	"./teaching11.jpg": 6136,
	"./teaching2.jpg": 3326,
	"./teaching3.jpg": 3483,
	"./teaching4.jpg": 8600,
	"./teaching5.jpg": 6213,
	"./teaching6.jpg": 8986,
	"./teaching7.jpg": 919,
	"./teaching8.jpg": 5764,
	"./teaching9.jpg": 5713,
	"./tour.jpg": 1565,
	"./tradition.jpg": 1767,
	"./word.jpg": 8603
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5760;